<template lang="pug">
div
  stock-take-summary-desktop(:id="id" :clinic-slug="warehouseSlug" list-page="HQInventoryStockTake")
</template>

<script>
import StockTakeSummaryDesktop from '@/components/clinic/inventory/stocktake/StockTakeSummaryDesktop.vue'

export default {
  components: { StockTakeSummaryDesktop },
  props: ['id'],
  computed: {
    warehouseSlug () {
      return this.$route.query.warehouseSlug
    }
  }
}
</script>
